module.exports = __webpack_public_path__ + "static/media/firefox.d7e10791.svg";